"use strict";

window.addEventListener("load", function() {


    const selectedGender    = document.querySelector('[name="gender_selected"]');
    const birthDateInput = document.querySelector('[name="birth_date"]');
    const today = new Date();
    today.setDate(today.getDate() - 1);
    const yesterday = today.toISOString().split('T')[0];
    birthDateInput.setAttribute('max', yesterday);

    const genderInput = document.querySelector('[name="gender"]');
    fetch('/api/gender-options')
        .then(response => response.json())
        .then(data => {
            data.forEach(option => {
                const opt = document.createElement('option');
                opt.value = option.id;
                opt.textContent = option.name;
                genderInput.appendChild(opt);
            });

           // Establecer el valor seleccionado si existe
            if (selectedGender && selectedGender.value) {
                genderInput.value = selectedGender.value; // Establece el valor
            }
        })

        .catch(error => console.error('Error fetching gender options:', error));
});


var EnvioFormPaso1 = function() {
    var t, e, i;

      // Función para validar el RUT chileno
    function validateRUT(value) {
        value = value.replace(/\./g, '').replace('-', '').toUpperCase();
        if (!/^[0-9]+[K0-9]$/.test(value)) return false;

        let rutBody = value.slice(0, -1);
        let dv = value.slice(-1);

        let sum = 0, multiplier = 2;
        for (let i = rutBody.length - 1; i >= 0; i--) {
            sum += parseInt(rutBody[i]) * multiplier;
            multiplier = multiplier === 7 ? 2 : multiplier + 1;
        }

        let dvExpected = 11 - (sum % 11);
        dvExpected = dvExpected === 10 ? 'K' : dvExpected === 11 ? '0' : dvExpected.toString();

        return dv === dvExpected;
    }

    // Función para restringir caracteres permitidos en el campo de RUT
    function restrictRUTInput(e) {
        const allowedKeys = /^[0-9kK\b]+$/; // Números, letra K/k y retroceso (borrar)
        if (!allowedKeys.test(e.key) && e.key !== 'Backspace') {
            e.preventDefault();
        }
    }

    // Función para formatear y validar el RUT al perder el foco
    function formatRUTOnBlur(e) {
        const value = e.target.value.replace(/\./g, '').replace('-', '').toUpperCase();

        if (value.length > 1) {
            const rutBody = value.slice(0, -1);
            const dv = value.slice(-1);
            e.target.value = `${rutBody}-${dv}`;
        }

        // Validar el RUT después de formatearlo
        const errorContainer = e.target.closest('.fv-row').querySelector('.fv-plugins-message-container');
        if (!validateRUT(e.target.value)) {
            // Mostrar mensaje de error en el contenedor
            if (errorContainer) {
                errorContainer.innerHTML = '<div class="invalid-feedback">El RUT ingresado no es válido.</div>';
            }
            e.target.classList.add('is-invalid'); // Marcar el campo como inválido
        } else {
            // Limpiar el mensaje de error si el RUT es válido
            if (errorContainer) {
                errorContainer.innerHTML = '';
            }
            e.target.classList.remove('is-invalid'); // Remover la marca de campo inválido
        }
    }

    // Función para restringir la entrada del campo teléfono a solo números
    function restrictPhoneInput(e) {
        const allowedKeys = /^[0-9\b]+$/; // Solo números y retroceso
        if (!allowedKeys.test(e.key)) {
            e.preventDefault();
        }
    }

    function restrictNameInput(e) {
        const allowedKeys = /^[A-Za-zÀ-ÿ\s'-]+$/; // Permitir solo letras, espacios, apóstrofes y guiones
        if (!allowedKeys.test(e.key) && e.key !== 'Backspace') {
            e.preventDefault();
        }
    }

    return {
        init: function() {
            i = document.querySelector("#suscriptions_step_1_form");
            t = document.getElementById("kt_careers_submit_button");

            // Configuración de validación
            e = FormValidation.formValidation(i, {
                fields: {
                    social_id: {
                        validators: {
                            notEmpty: {
                                message: "RUT es requerido."
                            },
                            callback: {
                                message: "RUT inválido.",
                                callback: function (input) {
                                    return validateRUT(input.value);
                                }
                            }
                        }
                    },
                    first_name: {
                        validators: {
                            notEmpty: {
                                message: "Nombre es requerido."
                            },
                            stringLength: {
                                max: 100,
                                message: "El nombre no debe exceder los 100 caracteres."
                            }
                        }
                    },
                    last_name: {
                        validators: {
                            notEmpty: {
                                message: "Apellido es requerido."
                            },
                            stringLength: {
                                max: 100,
                                message: "El apellido no debe exceder los 100 caracteres."
                            }
                        }
                    },
                    phone: {
                        validators: {
                            notEmpty: {
                                message: "Teléfono es requerido."
                            },
                            stringLength: {
                                min: 11,
                                max: 16,
                                message: "El teléfono debe tener entre 11 y 16 dígitos."
                            },
                            regexp: {
                                regexp: /^[0-9]+$/,
                                message: "El teléfono solo puede contener números."
                            }
                        }
                    },
                    email: {
                        validators: {
                            notEmpty: {
                                message: "Por favor ingresa tu correo."
                            },
                            regexp: {
                                regexp: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                message: "Email inválido. Por favor revisa los datos ingresados."
                            },
                            stringLength: {
                                max: 100,
                                message: "Email inválido. Por favor revisa los datos ingresados."
                            }
                        }
                    },
                    birth_date: { validators: { notEmpty: { message: "La fecha de nacimiento es requerida" } } },
                    gender: { validators: { notEmpty: { message: "El género es requerido" } } }
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: ".fv-row",
                        eleInvalidClass: "is-invalid",
                        eleValidClass: "is-valid"
                    })
                }
            });
            // Escuchar eventos en el campo de RUT
            const rutField = i.querySelector('[name="social_id"]');
            if (rutField) {
                rutField.addEventListener('keypress', restrictRUTInput); // Restringir caracteres
                rutField.addEventListener('blur', formatRUTOnBlur); // Formatear y validar al perder el foco
            }

            // Escuchar eventos en el campo first_name
            const firstNameField = i.querySelector('[name="first_name"]');
            if (firstNameField) {
                firstNameField.addEventListener('keypress', restrictNameInput); // Restringir caracteres
            }

            // Escuchar eventos en el campo last_name
            const lastNameField = i.querySelector('[name="last_name"]');
            if (lastNameField) {
                lastNameField.addEventListener('keypress', restrictNameInput); // Restringir caracteres
            }

            // Escuchar eventos en el campo de teléfono
            const phoneField = i.querySelector('[name="phone"]');
            if (phoneField) {
                phoneField.addEventListener('keypress', restrictPhoneInput); // Restringir a solo números
            }

            // Manejar el envío del formulario
            t.addEventListener("click", function (i) {
                i.preventDefault();
                e && e.validate().then(function (e) {
                    console.log("validated!");
                    if (e === "Valid") {
                        t.setAttribute("data-kt-indicator", "on");
                        t.disabled = true;
                        setTimeout(function () {
                            const form = document.querySelector("#suscriptions_step_1_form");
                            form.submit(); // Enviar el formulario
                        }, 2000);
                    } else {
                        Swal.fire({
                            text: "Hemos detectado algunos problemas en los datos ingresados, por favor corregir para poder avanzar al siguiente paso.",
                            icon: "error",
                            buttonsStyling: false,
                            confirmButtonText: "OK, entiendo!",
                            customClass: {
                                confirmButton: "btn btn-primary"
                            }
                        }).then(function () {
                            KTUtil.scrollTop();
                        });
                    }
                });
            });
        }
    };
}();

KTUtil.onDOMContentLoaded(function () {
    EnvioFormPaso1.init();
});
